<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title" title="TaxPay">税款缴纳</li>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="state.showAgent = true"
        v-if="$judge_auth('84')"
      >
        从税局获取欠费信息
      </el-button>
      <el-button
        type="primary"
        link
        icon="Tickets"
        @click="onUpdate"
        v-if="$judge_auth('85')"
      >
        更新缴款结果
      </el-button>
      <el-button
        type="danger"
        link
        icon="Tickets"
        @click="onSubmit"
        v-if="$judge_auth('86')"
      >
        立即缴款
      </el-button>
      <el-button
        type="danger"
        link
        icon="Tickets"
        @click="onCancel"
        v-if="$judge_auth('87')"
      >
        作废电子票税号
      </el-button>
      <el-button
        type="primary"
        link
        icon="Tickets"
        @click="state.showSuccess = true"
        v-if="$judge_auth('88')"
      >
        开具完税证明
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click="state.showSuccessLog = true"
      >
        完税证明操作记录
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click.stop="state.showLog = true"
        v-if="$judge_auth('89')"
      >
        操作记录
      </el-button>
      <el-button type="primary" :icon="Upload" link @click="onExport">
        导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.pay_type"
        arrName="taxpay_pay_type"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-radio-group v-model="state.params.pay_status" @change="onLoad">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button :value="0">未缴款</el-radio-button>
        <el-radio-button :value="1">已缴款</el-radio-button>
      </el-radio-group>
      <el-date-picker
        v-model="state.params.tax_month"
        type="month"
        placeholder="税款所属期"
        value-format="YYYY-MM"
        format="YYYY年M月"
        :clearable="false"
      />
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-select
        v-model="state.params.tax_bureau_id"
        placeholder="税局"
        style="width: 260px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column label="缴款类型" :width="120">
          <template #default="{ row }">
            <c_status arrName="taxpay_pay_type" :value="row.pay_type" />
          </template>
        </el-table-column>
        <el-table-column
          prop="withholding_agent_name"
          label="企业名称"
          :formatter="$tab_TextFormat"
          :min-width="200"
        />
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_TextFormat"
          :min-width="200"
        />
        <el-table-column label="所得类型" :width="120">
          <template #default="{ row }">
            <c_status
              arrName="taxdeclare_declare_type"
              :value="row.declare_type"
            />
          </template>
        </el-table-column>
        <el-table-column label="欠费状态" :width="120">
          <template #default="{ row }">
            <c_status arrName="taxpay_qfzt" :value="row.qfzt" />
          </template>
        </el-table-column>
        <el-table-column label="缴款状态" :width="120" align="center">
          <template #default="{ row }">
            <text :style="{ color: row.pay_status ? '#080' : '#f00' }">{{
              row.pay_status ? "已缴款" : "未缴款"
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="jksbyy"
          label="失败原因"
          :formatter="$tab_TextFormat"
          :min-width="160"
        />
        <el-table-column
          prop="ybtse"
          label="应补(退)缴金额"
          :formatter="$tab_PriceFormat"
          align="center"
          :width="120"
        />
        <el-table-column
          prop="znje"
          label="滞纳金"
          :formatter="$tab_PriceFormat"
          align="center"
          :width="120"
        />
        <el-table-column
          prop="pay_money"
          label="实际缴款金额"
          :formatter="$tab_PriceFormat"
          align="center"
          :width="120"
        />
        <el-table-column
          prop="pay_channel"
          label="缴款渠道"
          :formatter="$tab_TextFormat"
          align="center"
          :width="120"
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          v-if="$judge_auth('86')"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Upload"
              @click="onSingleSubmit(row)"
            >
              缴款
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局获取欠费信息"
        @close="state.showAgent = false"
      >
        <c_Agent
          v-if="state.showAgent"
          :skssq="state.params.tax_month"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showSuccess"
        title="开具完税证明"
        @close="state.showSuccess = false"
      >
        <c_Success
          v-if="state.showSuccess"
          :skssq="state.params.tax_month"
          @close="state.showSuccess = false"
          @confirm="
            state.showSuccess = false;
            onLoad();
          "
        ></c_Success>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_TaxPayLog v-if="state.showLog"></c_TaxPayLog>
    </el-drawer>
    <el-drawer
      v-model="state.showSuccessLog"
      title="完税证明操作记录"
      size="70%"
    >
      <c_TaxPaySuccessLog v-if="state.showSuccessLog"></c_TaxPaySuccessLog>
    </el-drawer>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showSfxy"
        title="选择三方协议"
        @close="state.showSfxy = false"
      >
        <c_TaxPaySelectSfxy
          @close="state.showSfxy = false"
          :ids="state.selectIds"
        ></c_TaxPaySelectSfxy>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_customer_select, data_taxbureau_select } from "@/http/data";
import {
  taxpay_list,
  taxpay_pay,
  taxpay_update,
  taxpay_cancel,
  taxpay_export,
} from "@/http/taxpay";
import { ElMessage, ElMessageBox, dayjs } from "element-plus";

import c_Agent from "./SelectWithholdingAgent.vue";
import c_Success from "./SetSuccess.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_value: "desc",
  };
}
export default {
  components: {
    c_Agent,
    c_Success,
  },
  setup() {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.tax_month = dayjs().subtract(1, "month").format("YYYY-MM");

      onLoadCustomer();
      onLoadTaxBureau();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      taxpay_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    //立即缴款
    const onSingleSubmit = (row) => {
      ElMessageBox.confirm("请选择缴款方式！", "立即缴款", {
        confirmButtonText: "三方协议缴款",
        cancelButtonText: "银联缴款",
        confirmButtonClass: "el-button--primary",
        cancelButtonClass: "el-button--warning",
        distinguishCancelAndClose: true,
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action == "confirm") {
            state.selectIds = row.id;
            done();
            state.showSfxy = true;
          } else if (action == "cancel") {
            ElMessageBox.confirm(
              `您选择了<strong style='color:#1e90ff'>银联缴款</strong>方式，是否立即缴款？`,
              "缴款",
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "立即缴款",
                cancelButtonText: "取消",
                type: "warning",
              },
            ).then(() => {
              const data = {
                pay_type: 2,
                id: row.id,
              };
              taxpay_pay(data).then((res) => {
                if (res.status == 200) {
                  ElMessage.success(res.data.msg);
                  done();
                  onLoad();
                }
              });
            });
          } else {
            done();
          }
        },
      });
    };

    //批量缴款
    const onSubmit = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm("请选择缴款方式！", "立即缴款", {
        confirmButtonText: "三方协议缴款",
        cancelButtonText: "银联缴款",
        confirmButtonClass: "el-button--primary",
        cancelButtonClass: "el-button--warning",
        distinguishCancelAndClose: true,
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action == "confirm") {
            state.selectIds = rows.map((m) => m.id).join(",");
            done();
            state.showSfxy = true;
          } else if (action == "cancel") {
            ElMessageBox.confirm(
              `您选择了<strong style='color:#1e90ff'>银联缴款</strong>方式，是否立即缴款？`,
              "缴款",
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "立即缴款",
                cancelButtonText: "取消",
                type: "warning",
              },
            ).then(() => {
              const data = {
                pay_type: 2,
                id: rows.map((m) => m.id).join(","),
              };
              taxpay_pay(data).then((res) => {
                if (res.status == 200) {
                  ElMessage.success(res.data.msg);
                  done();
                  onLoad();
                }
              });
            });
          } else {
            done();
          }
        },
      });
    };

    const onUpdate = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#1e90ff'>${rows.length}</strong>条数据，是否立即<strong style='color:#ffa500'>更新已选单位的缴款结果</strong>？`,
        "更新缴款结果",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即更新",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        taxpay_update(rows.map((m) => m.id).join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //作废电子税票哦
    const onCancel = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#1e90ff'>${rows.length}</strong>条数据，是否立即<strong style='color:#ffa500'>作废其电子税</strong>？`,
        "作废电子税票",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定作废",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        taxpay_cancel(rows.map((m) => m.id).join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      taxpay_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onLoadTaxBureau,
      onRowClick,
      onSingleSubmit,
      onSubmit,
      onUpdate,
      onCancel,
      onExport,
    };
  },
};
</script>
<style scoped></style>
